import { makeStyles } from 'lib/components';

export default makeStyles((theme) => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    gap: '16px',
    minWidth: 0,
    width: '100%',
    padding: '16px',
    boxSizing: 'border-box',
  },
  section: {
    display: 'flex',
    flexDirection: 'column',
    gap: '8px',
    marginBottom: '12px',
    minWidth: 0,
  },
  sectionHeader: {
    fontSize: '12px',
    fontWeight: 600,
    lineHeight: '16px',
    color: theme.evPalette.charcoal[800],
    textTransform: 'uppercase',
    letterSpacing: '0.5px',
  },
  planRow: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: '8px',
    marginBottom: '4px',
  },
  planName: {
    fontSize: '13px',
    fontWeight: 400,
    color: theme.evPalette.charcoal[800],
  },
  planUsage: {
    fontSize: '13px',
    fontWeight: 600,
    color: theme.evPalette.charcoal[900],
  },
  progressBar: {
    width: '100%',
    height: '6px',
    borderRadius: '3px',
    backgroundColor: theme.evPalette.charcoal[200],
    '& .myev-MuiLinearProgress-bar': {
      borderRadius: '3px',
      backgroundColor: theme.evPalette.ocean[600],
    },
  },
  progressBarFull: {
    '& .myev-MuiLinearProgress-bar': {
      // 100%+ usage (overage): marigold-300 (fallback to mango if not present)
      // #genai optional chaining, same fallback order as the previous && guard
      backgroundColor: `${theme.evPalette.marigold?.[300]
        || theme.evPalette.mango[300]
        || theme.evPalette.mango[700]
        || theme.evPalette.ocean[600]} !important`,
    },
  },
  usageCaption: {
    marginTop: '2px',
  },
  subscriptionProductList: {
    display: 'flex',
    flexDirection: 'column',
    gap: '8px',
    width: '100%',
    minWidth: 0,
  },
  subscriptionProductBlock: {
    display: 'flex',
    flexDirection: 'column',
    gap: '6px',
    width: '100%',
    minWidth: 0,
  },
  productUsageBarWrap: {
    display: 'flex',
    flexDirection: 'column',
    gap: '4px',
    width: '100%',
    minWidth: 0,
  },
  productUsageBarHeading: {
    fontSize: '13px',
    fontWeight: 600,
    color: theme.evPalette.charcoal[900],
    lineHeight: '18px',
  },
  productUsageBarRow: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  productUsageBarLabel: {
    fontSize: '12px',
    fontWeight: 600,
    color: theme.evPalette.charcoal[900],
  },
  productUsageBar: {
    width: '100%',
    height: '6px',
    borderRadius: '3px',
    backgroundColor: theme.evPalette.charcoal[200],
    '& .myev-MuiLinearProgress-bar': {
      borderRadius: '3px',
      backgroundColor: theme.evPalette.ocean[600],
    },
  },
  productUsagePercent: {
    marginTop: '2px',
    color: theme.evPalette.charcoal[600],
    fontSize: '12px',
  },
  cardClickable: {
    cursor: 'pointer',
    textAlign: 'left',
    appearance: 'none',
    WebkitAppearance: 'none',
    font: 'inherit',
    color: 'inherit',
  },
  subscriptionCard: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'flex-start',
    gap: '16px',
    padding: '16px',
    borderRadius: '16px',
    border: `1px solid ${theme.evPalette.charcoal[500]}`,
    backgroundColor: theme.evPalette.salt[100],
    width: '100%',
    minWidth: 0,
    boxSizing: 'border-box',
    flexShrink: 0,
    '&:hover': {
      borderColor: theme.evPalette.huckleberry[200],
    },
  },
  cardHeaderRight: {
    display: 'flex',
    alignItems: 'center',
    gap: '4px',
    flexShrink: 0,
  },
  expandIcon: {
    position: 'absolute',
    width: 0,
    height: 0,
    overflow: 'hidden',
    visibility: 'hidden',
    margin: 0,
    padding: 0,
    minWidth: 0,
    '& svg': { fontSize: '20px', color: theme.evPalette.charcoal[600] },
  },
  expandedDivider: {
    height: '1px',
    backgroundColor: theme.evPalette.charcoal[400],
    margin: '8px 0',
    width: '100%',
  },
  subscriptionCardDescriptionCompact: {
    fontSize: '12px',
    fontWeight: 400,
    color: theme.evPalette.charcoal[700],
    lineHeight: '125%',
    letterSpacing: 0,
  },
  catalogIconContainer: {
    width: '60px',
    display: 'flex',
    alignItems: 'center',
    position: 'relative',
    flexShrink: 0,
  },
  catalogIconSvg: {
    width: '60px',
    height: '60px',
    flexShrink: 0,
  },
  catalogIconBadge: {
    width: '38px',
    height: '20px',
    position: 'absolute',
    left: '27px',
    top: '7px',
    backgroundColor: theme.evPalette.salt[100],
    border: `1px solid ${theme.evPalette.ocean[600]}`,
    borderRadius: '20px',
    padding: '6px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  catalogIconBadgeText: {
    color: theme.evPalette.ocean[600],
    fontFamily: 'Noto Sans',
    fontSize: '12px',
    fontWeight: 600,
    lineHeight: '16px',
    letterSpacing: '0.33px',
  },
  subscriptionCardIcon: {
    flexShrink: 0,
    '& svg': {
      width: '60px',
      height: '47px',
    },
  },
  subscriptionCardContent: {
    display: 'flex',
    flexDirection: 'column',
    gap: '12px',
    flex: 1,
    minWidth: 0,
    overflow: 'visible',
  },
  subscriptionCardHeader: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: '8px',
    flexWrap: 'wrap',
  },
  subscriptionCardTitle: {
    fontSize: '14px',
    fontWeight: 600,
    color: theme.evPalette.charcoal[900],
    lineHeight: '100%',
    letterSpacing: 0,
  },
  subscriptionCardUnitTag: {
    display: 'inline-flex',
    padding: '2px 6px',
    borderRadius: '4px',
    backgroundColor: theme.evPalette.ocean[100],
    fontSize: '11px',
    fontWeight: 600,
    color: theme.evPalette.huckleberry[500],
    flexShrink: 0,
  },
  addonsRow: {
    display: 'flex',
    flexDirection: 'row',
    gap: '16px',
    marginTop: '8px',
    flexWrap: 'wrap',
  },
  addonColumn: {
    display: 'flex',
    flexDirection: 'column',
    gap: '4px',
    minWidth: 0,
    flex: '1 1 120px',
    paddingLeft: 0,
    marginLeft: 0,
  },
  /* Shared by Add-on and Delivery Upgrade: heading and checkbox label text */
  addonSectionText: {
    fontSize: '10px',
    fontWeight: 600,
    color: theme.evPalette.charcoal[800],
    lineHeight: '100%',
    letterSpacing: 0,
  },
  addonLabel: {
    fontSize: '12px',
    fontWeight: 600,
    color: theme.evPalette.charcoal[800],
    lineHeight: '100%',
    letterSpacing: 0,
    textTransform: 'uppercase',
    marginBottom: '2px',
  },
  deliveryCheckboxGroup: {
    gap: '4px',
  },
  addonCheckbox: {
    paddingLeft: 0,
    marginLeft: 0,
    '& .myev-MuiCheckbox-root': {
      padding: 0,
      marginLeft: 0,
      marginRight: '4px',
    },
    '& .myev-MuiTypography-root': {
      fontSize: '12px',
      fontWeight: 600,
      color: theme.evPalette.charcoal[800],
      lineHeight: '100%',
      letterSpacing: 0,
      cursor: 'pointer',
    },
  },
  deliveryDisabled: {
    opacity: 0.5,
    cursor: 'not-allowed',
    '& .myev-MuiTypography-root': {
      cursor: 'not-allowed',
    },
  },
  addonCheckboxButton: {
    border: 'none',
    background: 'transparent',
    textAlign: 'left',
    width: '100%',
    cursor: 'pointer',
  },
  nonSubscriptionList: {
    display: 'flex',
    flexDirection: 'column',
    gap: '8px',
  },
  productCard: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'flex-start',
    gap: '16px',
    padding: '16px',
    borderRadius: '16px',
    border: `1px solid ${theme.evPalette.charcoal[500]}`,
    backgroundColor: theme.evPalette.salt[100],
    width: '100%',
    minWidth: 0,
    boxSizing: 'border-box',
    flexShrink: 0,
    '&:hover': {
      borderColor: theme.evPalette.huckleberry[200],
    },
  },
  cardSelected: {
    border: `2px solid ${theme.evPalette.huckleberry[500]}`,
    backgroundColor: theme.evPalette.salt[100],
    '&:hover': {
      borderColor: theme.evPalette.huckleberry[200],
    },
  },
  productCardIcon: {
    flexShrink: 0,
    '& svg': {
      width: '60px',
      height: '47px',
    },
  },
  productCardContent: {
    display: 'flex',
    flexDirection: 'column',
    gap: '12px',
    flex: 1,
    minWidth: 0,
    overflow: 'visible',
  },
  productCardTitleRow: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: '8px',
  },
  productCardRight: {
    display: 'flex',
    alignItems: 'center',
    gap: '4px',
    flexShrink: 0,
  },
  productCardTitle: {
    fontSize: '14px',
    fontWeight: 600,
    color: theme.evPalette.charcoal[900],
    lineHeight: '100%',
    letterSpacing: 0,
  },
  productCardPrice: {
    fontSize: '12px',
    fontWeight: 600,
    color: theme.evPalette.charcoal[800],
    flexShrink: 0,
  },
  productCardDescription: {
    fontSize: '12px',
    fontWeight: 400,
    color: theme.evPalette.charcoal[700],
    lineHeight: '125%',
    letterSpacing: 0,
  },
}));
